// extracted by mini-css-extract-plugin
export var resizer = "_gk-0";